import React from 'react';
import bulmaExtensions from 'bulma-extensions';

export default class Understanding extends React.Component {
  state = {
    carousels: []
  }

  componentDidMount() {
    this.setState({ carousels: bulmaExtensions.bulmaCarousel.attach() });
  }

  render() {
    return <div className="content">
      <h1 className="title is-3">Understanding Your Report</h1>
      <div className='carousel carousel-animated carousel-animate-slide' data-autoplay="true">
        <div className='carousel-container'>

          <div className='carousel-item has-background is-active'>
            <img className="is-background" src="/assets/images/report1.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>

          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report2.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>

          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report3.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>
          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report4.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>
          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report5.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>
          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report6.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>
          <div className='carousel-item has-background'>
            <img className="is-background" src="/assets/images/report7.jpg" alt="" width="640" height="310" />
            <div className="title"></div>
          </div>
        </div>
        <div className="carousel-navigation is-overlay">
          <div className="carousel-nav-left">
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </div>
          <div className="carousel-nav-right">
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <p>Pre-assessment reports help you to track your progress and communicate efficiently.</p>
      <p>The CCI Pre-Assessment summary report is designed to help you be an active agent in your care. It collects your responses to routine questions and organizes information into displays you can view and share with your care providers.</p>
      <p>My current treatments:</p>

      <p>This chart shows treatments you reported for the last week and your comments.</p>

      <p>Mood Symptoms in the past week</p>

      <p>My symptoms on a common ordinal scale: DSM criteria view</p>
      <p>Drawing on the same information sources shown in the tables below, this display transforms the information into a graph where your responses are plotted in relation to the criteria clinicians use to diagnose episodes of depression and mood elevation.</p>
      <p>The measure summary: The tables displayed here show scores for formal measures you completed this week.</p>
      <p>The measures are based on scales commonly used in research. Since not all clinicians are familiar with the scales, brief explanations can be found on the next page.</p>
      <p>hypomania/mania. The green bars show scores from your self-report. The blue and red bars show scores as judged by a computer simulated clinical rater.</p>
      <p>All rating scale scores require interpretation by a qualified clinician</p>
      <p>My progress over time:</p>
      <p>These line graphs give a longitudinal view of your scores over time. Many care providers will find these scores meaningful, because the same scales are commonly used to track response to treatment in clinical trials. The line for Depression MADRS is blue. The line for Mood elevation YMRS is red, and the line for Life Enjoyment QLESQ is gold. </p>
      <p>To understand how this report applies to your care, discuss the guidance below with your care providers.</p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/more/Understanding.js